export default __webpack_public_path__ + "static/media/status-alert.3873993e.svg";